<script>
import { mapActions } from "vuex";

export default {
  name: "ScriptLoaderLiveBuy",
  data() {
    return {
      liveBuy: null,
    };
  },
  mounted() {
    this.initLiveBuy();
  },
  beforeDestroy() {
    this.liveBuy?.unregisterAllCartCallbacks();
  },
  methods: {
    ...mapActions({
      addProductToCart: "shoppingCart/addProductToCart",
      removeProductFromCart: "shoppingCart/removeProductFromCart",
    }),
    initLiveBuy() {
      const script = document.createElement("script");
      script.setAttribute("src", "https://sdk.livebuy.io/livebuy-sdk.js");
      script.onload = () => {
        this.liveBuy = window.livebuy;
        this.liveBuy.registerCartCallback(this.registerCartCallback);
      };
      document.head.appendChild(script);
    },
    registerCartCallback(data) {
      const variant_id = data.item?.productNumber;
      if (data.action == "add_product") this.addProductToCart({ variant_id });
      if (data.action == "remove_product") this.removeProductFromCart({ variant_id });
    },
  },
  render() {
    return "";
  },
};
</script>
